import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";

const TicketTableRow = ({ row, columns = [] }) => {
  const defaultRenderer = (column) => {
    const rawValue = column.valueGetter ? column.valueGetter(row) : row[column.key];
    const value = rawValue ?? "";
    const displayValue = typeof value === "string" ? value : String(value);

    return (
      <p className="block truncated-text font-18-400-24 text-black-4" title={displayValue}>
        {displayValue}
      </p>
    );
  };

  const renderCreated = () => {
    const creationdate = row.creationdate;

    if (!creationdate) {
      return <p className="block font-18-400-24 text-black-4">--</p>;
    }

    return (
      <p className="block font-18-400-24 text-black-4" title={moment.utc(creationdate).fromNow()}>
        {moment.utc(creationdate).utcOffset(-5).format("MMM D, YYYY h:mm A")}
      </p>
    );
  };

  const renderView = () => (
    <button className="border-none bg-transparent p-0" type="button">
      <Link to={`/manage-ticket/ticket/view/${row.id}`}>
        <img className="size-16" src="./read.svg" alt="View" />
      </Link>
    </button>
  );

  const renderEdit = () => (
    <button className="border-none bg-transparent p-0" type="button">
      <Link to={`/manage-ticket/ticket/edit/${row.id}`}>
        <img className="size-16" src="./edit.svg" alt="Edit" />
      </Link>
    </button>
  );

  const renderers = {
    created: renderCreated,
    view: renderView,
    action: renderEdit,
  };

  const cellClassName = (columnKey) =>
    columnKey === "view" || columnKey === "action" ? "p-1 text-center" : "p-2";

  return (
    <tr key={row.id}>
      {columns.map((column) => (
        <td key={column.key} className={cellClassName(column.key)}>
          {(renderers[column.key] || defaultRenderer)(column)}
        </td>
      ))}
    </tr>
  );
};

export default TicketTableRow;
